import { createContext } from "react";
import axiosInstance from "../api/axios";

export const DiscountCodeContext = createContext();

async function addDiscountCode(discountData) {
  try {
    const res = await axiosInstance.post("/admin/discount-codes", discountData);
    return res;
  } catch (error) {
    throw error;
  }
}

async function getDiscountCodes() {
  try {
    const res = await axiosInstance.get("/admin/discount-codes");
    // API returns: { status: "success", data: [...] }
    if (res.data) {
      if (res.data.status === "success" && res.data.data) {
        return res.data;
      }
      if (Array.isArray(res.data)) {
        return { status: "success", data: res.data };
      }
      if (res.data.data && Array.isArray(res.data.data)) {
        return res.data;
      }
    }
    return { status: "success", data: [] };
  } catch (error) {
    console.error("Error fetching discount codes:", error);
    throw error;
  }
}

async function getDiscountCodeById(id) {
  try {
    const res = await axiosInstance.get(`/admin/discount-codes/${id}`);
    return res.data.data || res.data || res.data.discountCode;
  } catch (error) {
    console.error("Error fetching discount code:", error);
    throw error;
  }
}

async function validateDiscountCode(code, planId, registrationType) {
  try {
    const params = new URLSearchParams();
    if (planId) params.append("planId", planId);
    if (registrationType) params.append("registrationType", registrationType);
    
    const queryString = params.toString();
    const url = `/discount-codes/validate/${code}${queryString ? `?${queryString}` : ""}`;
    const res = await axiosInstance.get(url);
    return res.data;
  } catch (error) {
    console.error("Error validating discount code:", error);
    throw error;
  }
}

async function updateDiscountCode(id, discountData) {
  try {
    const res = await axiosInstance.patch(`/admin/discount-codes/${id}`, discountData);
    return res;
  } catch (error) {
    throw error;
  }
}

function removeDiscountCode(id) {
  return axiosInstance
    .delete(`/admin/discount-codes/${id}`)
    .then((response) => response)
    .catch((error) => {
      console.error("Error deleting discount code:", error);
      throw error;
    });
}

export default function DiscountCodeContextProvider({ children }) {
  return (
    <DiscountCodeContext.Provider
      value={{
        addDiscountCode,
        getDiscountCodes,
        getDiscountCodeById,
        validateDiscountCode,
        updateDiscountCode,
        removeDiscountCode,
      }}
    >
      {children}
    </DiscountCodeContext.Provider>
  );
}



